
export const INSIGHTS_SIMILAR_HOMES_ACTIONS = {
  SIMILAR_HOMES_API_ERROR: "SIMILAR_HOMES_API_ERROR",
  SIMILAR_HOMES_DATA_NOT_AVAILABLE: "SIMILAR_HOMES_DATA_NOT_AVAILABLE",
  SIMILAR_HOMES_SAVE_BILLING_CYCLE_PERIOD: "SIMILAR_HOMES_SAVE_BILLING_CYCLE_PERIOD",
  SIMILAR_HOMES_SET_HIGHCHARTS_DATA: "SIMILAR_HOMES_SET_HIGHCHARTS_DATA",
  SIMILAR_HOMES_SET_ARROW_DISABLED: "SIMILAR_HOMES_SET_ARROW_DISABLED",
  SIMILAR_HOMES_UPDATE_HIGHCHARTS_OBJECT: "SIMILAR_HOMES_UPDATE_HIGHCHARTS_OBJECT",
  SIMILAR_HOMES_SAVE_BC_DATA: "SIMILAR_HOMES_SAVE_BC_DATA",
  SIMILAR_HOMES_CHANGE_YEAR_OFFSET: "SIMILAR_HOMES_CHANGE_YEAR_OFFSET",
  SIMILAR_HOMES_COMPARISON_DATA: "SIMILAR_HOMES_COMPARISON_DATA",
  SIMILAR_HOMES_CHANGE_APPLIANCE: "SIMILAR_HOMES_CHANGE_APPLIANCE",
  SIMILAR_HOMES_SAVE_APPLIANCE_NAVBAR_LIST: "SIMILAR_HOMES_SAVE_APPLIANCE_NAVBAR_LIST",
  SIMILAR_HOMES_SAVE_CHART_API_PAYLOAD: "SIMILAR_HOMES_SAVE_CHART_API_PAYLOAD",
  RESET_DATA : "SIMILAR_HOMES_DATA_RESET"
};

export function apiError(payload) {
  return {
      type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_API_ERROR,
      payload
  }
}

export function dataNotAvailable(payload) {
  return {
      type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_DATA_NOT_AVAILABLE,
      payload
  }
}

export function saveBillingCyclePeriod(payload) {
  return {
      type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SAVE_BILLING_CYCLE_PERIOD,
      payload
  }
}

export function setSimilarHomesChartsData(payload) {
  return {
      type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SET_HIGHCHARTS_DATA,
      payload
  }
}

export function setArrowDisabled(payload) {
  return {
      type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SET_ARROW_DISABLED,
      payload
  }
}

export function updateHighChartsObject(payload) {
  return {
      type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_UPDATE_HIGHCHARTS_OBJECT,
      payload
  }
}

export function saveBCData(payload) {
  return {
      type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SAVE_BC_DATA,
      payload
  }
}

export function changeYearOffset(payload) {
  return {
      type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_CHANGE_YEAR_OFFSET,
      payload
  }
}

export function setSHCdata(payload) {
  return {
      type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_COMPARISON_DATA,
      payload
  }
}

export function changeSelectedSHCAppliance(payload) {
  return {
    type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_CHANGE_APPLIANCE,
    payload
  }
}

export function saveApplianceNavbarList(payload) {
  return {
    type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SAVE_APPLIANCE_NAVBAR_LIST,
    payload
  }
}

export function saveSHCChartPayload(payload) {
  return {
    type: INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SAVE_CHART_API_PAYLOAD,
    payload
  }
}